//
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { NavLink } from 'react-router-dom';
import { NavigationMenu } from 'axway-react-ui';

class ApplicationMenu extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.renderLinks = this.renderLinks.bind(this);
		this.links = [{
			sectionId: 'summary',
			path: '/summary',
			icon: 'clipboard-text',
			name: this.intl.formatMsg('Summary')
		}, {
			sectionId: 'apidocs',
			path: '/apidocs',
			icon: 'api',
			name: this.intl.formatMsg('API Doc & Test')
		}, {
			sectionId: 'flows',
			path: '/flows',
			icon: 'arrow-wave2',
			name: this.intl.formatMsg('Flows')
		}, {
			sectionId: 'models',
			path: '/models',
			icon: 'cube',
			name: this.intl.formatMsg('Models')
		}, {
			sectionId: 'configuration',
			path: '/configuration',
			icon: 'config-file',
			name: this.intl.formatMsg('Configuration')
		}, {
			sectionId: 'credentials',
			path: '/credentials',
			icon: 'key',
			name: this.intl.formatMsg('Credentials')
		}, {
			sectionId: 'components',
			path: '/plugins',
			icon: 'connector',
			name: this.intl.formatMsg('Plugins')
		}, {
			sectionId: 'updates',
			path: '/updates',
			icon: 'sync',
			name: this.intl.formatMsg('Updates')
		}];
	}

	/**
	 * Converts the notification type to a NotificationBadge accepted types.
	 *
	 * @param {string} notificationType The type of the notification - 'error'|'warning'|'ok'.
	 *
	 * @returns {string} One of the allowed NotificationBadge types.
	 */
	getBadgeStyle(notificationType) {
		const badgeStyles = {
			error: 'danger',
			warning: 'warning',
			ok: 'success',
			info: 'info'
		};

		return badgeStyles[notificationType] || 'info';
	}

	renderLinks() {
		return this.links.map(({ sectionId, path, icon, name }) => {
			const sectionNotifications = this.props.notifications.badges[sectionId];

			return (
				<NavLink key={`nav_${path}`} to={`${window.$conf.prefix}/project${path}`}>
					<span className={`gg icon-GG-${icon}`} />
					{name}

					{sectionNotifications && (
						<NavigationMenu.NotificationBadge
							notifications={sectionNotifications.count || true}
							bsStyle={this.getBadgeStyle(sectionNotifications.type)}
						/>
					)}
				</NavLink>
			);
		});
	}

	render() {
		const { collapsed, productName, productRelease, productVersion, onToggle } = this.props;
		return (
			<NavigationMenu
				onToggle={onToggle}
				collapsed={collapsed}
			>
				<NavigationMenu.Links>
					{this.renderLinks()}
				</NavigationMenu.Links>
				<NavigationMenu.ProductInfo
					docLink={window.$conf.docUIUrl}
					text={this.intl.formatMsg('{productName} v{version} ({productRelease})', { productName, productRelease, version: productVersion.split('.').slice(0, 1) })}
					// Remove prerelese tag from collapsed version number
					collapsedText={this.intl.formatMsg('v{version}', { version: productVersion.split('.').slice(0, 1) })}
				/>
			</NavigationMenu>
		);
	}
}

ApplicationMenu.propTypes = {
	productName: PropTypes.string.isRequired,
	productRelease: PropTypes.string.isRequired,
	productVersion: PropTypes.string.isRequired,
	collapsed: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
	notifications: PropTypes.object.isRequired
};

ApplicationMenu.defaultProps = {};

export default injectIntl(ApplicationMenu);
